var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { MobileBottomNavigationButtonType, PatientStudiesListViewTab, } from "./PatientResearchDashboardUIManager";
import { getTranslatedStudyText } from "./TranslationService";
import { Disposer } from "../Infra/Disposer";
import { FormModel } from "./FormModel";
import { getObservableT } from "../Infra/i18next";
import { ProjectType } from "healthex-common/study.dtos";
export const REVOCATION_REASON_MAX_LENGTH = 500;
export class PatientResearchStudyRevokeConsentViewModel {
    constructor(props) {
        var _a;
        this.modalStudyId = null;
        this.disposer = new Disposer();
        this.t = getObservableT("patients");
        this.formModel = new FormModel({
            revocationReason: "",
        }, ["revocationReason"], (input) => {
            if (input.revocationReason !== undefined) {
                this.formModel.clearErrors();
                if (input.revocationReason.length > REVOCATION_REASON_MAX_LENGTH) {
                    this.formModel.addError("revocationReason", `Reason cannot exceed ${REVOCATION_REASON_MAX_LENGTH} characters`);
                }
            }
        });
        this.patientStudyConsent = NOT_LOADED;
        this.isRevokeConsentButtonLoading = false;
        this.revokeStatus = null;
        this.closeRevokeConsentDialog = () => {
            if (this.revokeStatus) {
                this.revokeConsentRoute();
            }
            else {
                if (this.hideStudyRevokeConsentDialog) {
                    this.hideStudyRevokeConsentDialog();
                }
            }
        };
        this.studyManager = props.container.studyManager;
        this.patientResearchDashboardUIManager = props.container.patientResearchDashboardUIManager;
        this.patientConsentUIManager = props.container.patientConsentUIManager;
        this.routingUIManager = props.container.routingUIManager;
        this.authManager = props.container.authManager;
        this.modalStudyId = (_a = props.modalStudyId) !== null && _a !== void 0 ? _a : null;
        this.patientService = props.container.patientService;
        this.browserLanguageUIManager = props.container.browserLanguageUIManager;
        this.hideStudyRevokeConsentDialog = props.hideStudyRevokeConsentDialog;
        this.hideStudyDetailsDialog = props.hideStudyDetailsDialog;
    }
    run() {
        this.disposer.reaction(() => this.studyId, async () => {
            await this.refreshStudyConsent();
        }, { fireImmediately: true });
    }
    stop() {
        this.disposer.dispose();
    }
    get studyId() {
        var _a, _b, _c;
        return (_c = (_a = this.modalStudyId) !== null && _a !== void 0 ? _a : (_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.studyId) !== null && _c !== void 0 ? _c : null;
    }
    get study() {
        if (!this.patientStudyConsent)
            return null;
        if (this.patientStudyConsent === NOT_LOADED)
            return null;
        if (this.patientStudyConsent === null)
            return null;
        if (this.patientStudyConsent.study === null)
            return null;
        if (this.patientStudyConsent.consents === null)
            return null;
        return { ...this.patientStudyConsent.study, consents: this.patientStudyConsent.consents };
    }
    get patientFriendlyTitle() {
        var _a, _b, _c, _d;
        if (!this.study)
            return null;
        const translatedTitle = getTranslatedStudyText(this.study, "patientFriendlyTitle", this.browserLanguageUIManager.currentLanguage);
        return (_d = (_b = translatedTitle !== null && translatedTitle !== void 0 ? translatedTitle : (_a = this.study) === null || _a === void 0 ? void 0 : _a.patientFriendlyTitle) !== null && _b !== void 0 ? _b : (_c = this.study) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : null;
    }
    get organizationName() {
        if (!this.study)
            return null;
        return this.study.addedByOrganization.name;
    }
    get withdrawalMessage() {
        var _a, _b;
        return this.t("If you stop sharing, {{ organizationName }} will no longer access your records for the purposes of this request. Any information already shared before you stopped sharing won’t be affected.", {
            organizationName: ((_a = this.study) === null || _a === void 0 ? void 0 : _a.projectType) === ProjectType.AI_DATA_USE ? (_b = this.study) === null || _b === void 0 ? void 0 : _b.aiToolName : this.organizationName,
            projectTypeText: "request",
        });
    }
    get successWithdrawalMessage() {
        var _a, _b;
        return this.t("You’re no longer sharing your records for ‘{{ patientFriendlyTitle }}’.\n\n{{ organizationName }} can no longer access your records for this request, but may continue to access them for other requests.", {
            patientFriendlyTitle: this.patientFriendlyTitle,
            organizationName: ((_a = this.study) === null || _a === void 0 ? void 0 : _a.projectType) === ProjectType.AI_DATA_USE ? (_b = this.study) === null || _b === void 0 ? void 0 : _b.aiToolName : this.organizationName,
        });
    }
    async refreshStudyConsent() {
        if (this.studyId === null)
            return;
        if (this.authManager.id === null)
            return;
        this.patientStudyConsent = await this.patientService.getPatientStudyConsent(this.authManager.id, this.studyId, true);
    }
    revokeConsentRoute() {
        if (this.hideStudyRevokeConsentDialog) {
            this.hideStudyRevokeConsentDialog();
        }
        if (this.hideStudyDetailsDialog) {
            this.hideStudyDetailsDialog();
        }
        this.patientResearchDashboardUIManager.goToPage(MobileBottomNavigationButtonType.RESEARCH, PatientStudiesListViewTab.DECLINED);
    }
    async revokeConsent() {
        if (this.study === null)
            return;
        this.formModel.clearErrors();
        const reason = this.formModel.input.revocationReason.trim();
        if (!reason) {
            this.formModel.addError("revocationReason", "Please tell us your reason to continue.");
            return;
        }
        if (reason.length > REVOCATION_REASON_MAX_LENGTH) {
            this.formModel.addError("revocationReason", `Please keep your reason under ${REVOCATION_REASON_MAX_LENGTH} characters.`);
            return;
        }
        const consentingPatientInfo = this.authManager.consentingPatientInfo;
        if (!consentingPatientInfo)
            return;
        this.isRevokeConsentButtonLoading = true;
        const expirationDate = this.patientConsentUIManager.getConsentExpirationFromStudy(this.study);
        if (expirationDate === null) {
            this.closeRevokeConsentDialog();
            return;
        }
        try {
            const study = this.study;
            await this.studyManager.optOutOfStudy(consentingPatientInfo, study, this.study.consents.map((consent) => consent.consentType), { expirationDate, revocationReason: reason });
            this.revokeStatus = true;
        }
        finally {
            this.isRevokeConsentButtonLoading = false;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientResearchStudyRevokeConsentViewModel.prototype, "patientStudyConsent", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientResearchStudyRevokeConsentViewModel.prototype, "isRevokeConsentButtonLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientResearchStudyRevokeConsentViewModel.prototype, "revokeStatus", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "studyId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "study", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "patientFriendlyTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "organizationName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "withdrawalMessage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientResearchStudyRevokeConsentViewModel.prototype, "successWithdrawalMessage", null);
